"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _proposedYear;
// import { fetchDropdownData, generalMDMSDataRequestObj, getGeneralMDMSDataDropdownName, getTranslatedLabel } from "egov-ui-kit/utils/commons";


var _actions = require("egov-ui-kit/redux/common/actions");

var _actions2 = require("egov-ui-kit/redux/form/actions");

var _api = require("egov-ui-framework/ui-utils/api");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions3 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _actions4 = require("egov-ui-kit/redux/app/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "taxCalculation",
  fields: {
    proposedQtr: {
      id: "proposedQtr",
      jsonPath: "Properties[0].taxdetails.proposedQtr",
      required: true,
      disabled: true,
      localePrefix: true,
      labelsFromLocalisation: true,
      type: "AutocompleteDropdown",
      floatingLabelText: "Proposed QTR",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "Proposed Qtr required!",
      fullWidth: true,
      hintText: "PT_COMMONS_SELECT_PLACEHOLDER",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },

      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.proposedQtr", field.value));
      }
    },

    proposedYear: (_proposedYear = {
      id: "proposedYear",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.proposedYear",
      floatingLabelText: "Propsed Year",
      hintText: "Propsed Year",
      numcols: 6,
      required: true,
      errorMessage: "Proposed Year required!"
    }, (0, _defineProperty3.default)(_proposedYear, "errorMessage", "Enter valid year"), (0, _defineProperty3.default)(_proposedYear, "errorStyle", { position: "absolute", bottom: -8, zIndex: 5 }), (0, _defineProperty3.default)(_proposedYear, "pattern", "^[12][0-9]{3}$"), (0, _defineProperty3.default)(_proposedYear, "updateDependentFields", function updateDependentFields(_ref2) {
      var formKey = _ref2.formKey,
          field = _ref2.field,
          dispatch = _ref2.dispatch,
          state = _ref2.state;

      field.value && dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.proposedYear", field.value));
    }), _proposedYear),
    rrMonth: {
      id: "rrMonth",
      type: "number",
      jsonPath: "Properties[0].taxdetails.reasonableRent",
      floatingLabelText: "Resonable Rent/Month",
      hintText: "Resonable Rent/Month",
      numcols: 6,
      required: true,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        field.value && dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.reasonableRent", field.value.toString()));
      }
    },

    AV: {
      id: "AV",
      type: "number",
      jsonPath: "Properties[0].taxdetails.av",
      floatingLabelText: "AV",
      hintText: "AV",
      numcols: 3,
      required: true,
      disabled: true,
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },

      gridDefination: {
        xs: 4,
        sm: 4
      },
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.av", field.value));
      }
    },

    // TODO: Fix the Calculate AV functionality
    testButton: {
      id: "testButton",
      type: "button",
      onClickFunc: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(state, dispatch) {
          var proposedYearData, proposedQTRData, premiseTypeData, rrMonthData, payloadResponse, payload;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  proposedYearData = (0, _get2.default)(state, "form.taxCalculation.fields.proposedYear.value", "");
                  proposedQTRData = (0, _get2.default)(state, "form.taxCalculation.fields.proposedQtr.value", "");
                  premiseTypeData = (0, _get2.default)(state, "form.propertyAddress.fields.premisesType.value", "");
                  rrMonthData = (0, _get2.default)(state, "form.taxCalculation.fields.rrMonth.value", "");
                  payloadResponse = {};
                  // dispatch(toggleSnackbarAndSetText(true, { labelName: "clicked", labelKey: "clicked" }, "error"));

                  if (!(proposedQTRData && proposedYearData)) {
                    _context.next = 56;
                    break;
                  }

                  if (!(parseInt(proposedYearData) > 2016)) {
                    _context.next = 24;
                    break;
                  }

                  dispatch((0, _actions4.toggleSnackbarAndSetText)(true, { labelName: "No Tax", labelKey: "No Tax" }, "error"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commRate", "value", "50"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "howrghBridge", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "taxQtr", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "surcharge", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "payableAmount", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rebateAmount", "value", "0"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "netAmount", "value", "0"));

                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.commRate", "50"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.howrghBridge", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.taxQtr", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.surcharge", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.payableAmount", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.rebateAmount", "0"));
                  dispatch((0, _actions.prepareFormData)("Properties[0].taxdetails.netAmount", "0"));
                  _context.next = 54;
                  break;

                case 24:
                  _context.prev = 24;
                  _context.next = 27;
                  return (0, _api.httpRequest)("post", "property-services/property/_calculateArvTax", "", [], {
                    taxDetails: {
                      quarter: parseInt(proposedQTRData),
                      proposedQtr: parseInt(proposedYearData),
                      reasonableRent: parseInt(rrMonthData),
                      premisesType: premiseTypeData
                    }
                  });

                case 27:
                  payload = _context.sent;

                  payloadResponse = payload;

                  dispatch((0, _actions3.prepareFinalObject)("taxDetailsResponse", payloadResponse.taxDetails));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commRate", "value", "50"));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rrMonth", "value", payloadResponse.taxDetails.reasonableRent.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "AV", "value", payloadResponse.taxDetails.av.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "howrghBridge", "value", payloadResponse.taxDetails.hbtAmount.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "taxQtr", "value", payloadResponse.taxDetails.quarter.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "surcharge", "value", payloadResponse.taxDetails.surcharge.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "payableAmount", "value", payloadResponse.taxDetails.paybleAmount.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rebateAmount", "value", payloadResponse.taxDetails.rebateAmount.toString()));
                  dispatch((0, _actions2.setFieldProperty)("taxCalculation", "netAmount", "value", payloadResponse.taxDetails.netAmount.toString()));

                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commRate", "50"));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.reasonableRent", payloadResponse.taxDetails.reasonableRent.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.av", payloadResponse.taxDetails.av.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.hbtAmount", payloadResponse.taxDetails.hbtAmount.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.quateryAmount", payloadResponse.taxDetails.quateryAmount.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.surcharge", payloadResponse.taxDetails.surcharge.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.payableAmount", payloadResponse.taxDetails.paybleAmount.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.rebateAmount", payloadResponse.taxDetails.rebateAmount.toString()));
                  dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.netAmount", payloadResponse.taxDetails.netAmount.toString()));

                  return _context.abrupt("return", payload);

                case 51:
                  _context.prev = 51;
                  _context.t0 = _context["catch"](24);

                  console.log(_context.t0);

                case 54:
                  _context.next = 57;
                  break;

                case 56:
                  dispatch((0, _actions4.toggleSnackbarAndSetText)(true, { labelName: "Please enter Proposed QTR and Proposed Year", labelKey: "Please enter Proposed QTR and Proposed Year" }, "error"));

                case 57:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[24, 51]]);
        }));

        return function onClickFunc(_x, _x2) {
          return _ref5.apply(this, arguments);
        };
      }(),
      label: "Calculate AV",
      buttonType: true,
      numcols: 3,
      gridDefination: {
        xs: 2,
        sm: 2
      }
    },

    commRate: {
      id: "commRate",
      type: "number",
      jsonPath: "Properties[0].taxdetails.commRate",
      floatingLabelText: "Comm Rate",
      hintText: "Comm Rate",
      numcols: 6,
      disabled: true,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commRate", field.value));
      }
    },

    commAv: {
      id: "commAv",
      type: "number",
      jsonPath: "Properties[0].taxdetails.commAv",
      floatingLabelText: "Comm AV",
      hintText: "Comm AV",
      numcols: 6,
      required: true,
      disabled: true,
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commAv", field.value));
      }
    },

    howrghBridge: {
      id: "howrghBridge",
      type: "number",
      jsonPath: "Properties[0].taxdetails.hbtAmount",
      floatingLabelText: "Howrgh Bridge",
      hintText: "Howrgh Bridge",
      numcols: 6,
      disabled: true,

      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.hbtAmount", field.value));
      }
    },

    taxQtr: {
      id: "taxQtr",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.quateryAmount",
      floatingLabelText: "Tax/Qtr",
      hintText: "Tax/Qtr",
      numcols: 6,
      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.quateryAmount", field.value));
      }
    },

    surcharge: {
      id: "surcharge",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.surcharge",
      floatingLabelText: "Surcharge",
      hintText: "Surcharge",
      numcols: 6,

      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.surcharge", field.value));
      }
    },

    payableAmount: {
      id: "payableAmount",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.paybleAmount",
      floatingLabelText: "Payable Amount",
      hintText: "Payable Amount",
      numcols: 6,

      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref11) {
        var formKey = _ref11.formKey,
            field = _ref11.field,
            dispatch = _ref11.dispatch,
            state = _ref11.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.paybleAmount", field.value));
      }
    },

    rebateAmount: {
      id: "rebateAmount",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.rebateAmount",
      floatingLabelText: "Rebate Amount",
      hintText: "Rebate Amount",
      numcols: 6,

      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref12) {
        var formKey = _ref12.formKey,
            field = _ref12.field,
            dispatch = _ref12.dispatch,
            state = _ref12.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.rebateAmount", field.value));
      }
    },

    netAmount: {
      id: "netAmount",
      type: "number",
      disabled: true,
      jsonPath: "Properties[0].taxdetails.netAmount",
      floatingLabelText: "Net Amount",
      hintText: "Net Amount",
      numcols: 6,

      //errorMessage: "PT_PROPERTY_DETAILS_PINCODE_ERRORMSG",
      errorMessage: "PT_PINCODE_ERROR_MESSAGE",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      updateDependentFields: function updateDependentFields(_ref13) {
        var formKey = _ref13.formKey,
            field = _ref13.field,
            dispatch = _ref13.dispatch,
            state = _ref13.state;

        dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.netAmount", field.value));
      }
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    var propsedQTRDropDownData = [{
      name: "1",
      code: "1",
      label: "1",
      value: "1"
    }, {
      name: "2",
      code: "2",
      label: "2",
      value: "2"
    }, {
      name: "3",
      code: "3",
      label: "3",
      value: "3"
    }, {
      name: "4",
      code: "4",
      label: "4",
      value: "4"
    }];
    dispatch((0, _actions2.setFieldProperty)("taxCalculation", "proposedQtr", "dropDownData", propsedQTRDropDownData));

    function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var urlParams = getParameterByName("isInspection");
    if (urlParams == "yes") {
      var state = store.getState();
      var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties");
      var proposedQuarterNo = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.capturedProposed.proposedQuarterNo");
      var proposedQuarterYr = (0, _get2.default)(state.screenConfiguration, "preparedFinalObject.capturedProposed.proposedQuarterYr");

      if (data && data.length > 0) {
        var taxDetails = data[0].taxdetails;

        if (taxDetails && Object.keys(taxDetails).length > 0) {
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "proposedQtr", "value", proposedQuarterNo.toString()));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "proposedYear", "value", proposedQuarterYr.toString()));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rrMonth", "value", taxDetails.reasonableRent ? taxDetails.reasonableRent.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "AV", "value", taxDetails.av ? taxDetails.av.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commAv", "value", taxDetails.commAv ? taxDetails.commAv.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "commRate", "value", "50"));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "howrghBridge", "value", taxDetails.hbtAmount ? taxDetails.hbtAmount.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "taxQtr", "value", taxDetails.quateryAmount ? taxDetails.quateryAmount.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "surcharge", "value", taxDetails.surcharge ? taxDetails.surcharge.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "payableAmount", "value", taxDetails.paybleAmount ? taxDetails.paybleAmount.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "rebateAmount", "value", taxDetails.rebateAmount ? taxDetails.rebateAmount.toString() : 0));
          dispatch((0, _actions2.setFieldProperty)("taxCalculation", "netAmount", "value", taxDetails.netAmount ? taxDetails.netAmount.toString() : 0));

          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.proposedQtr", proposedQuarterNo));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.proposedYear", proposedQuarterYr));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.reasonableRent", taxDetails.reasonableRent ? taxDetails.reasonableRent.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.av", taxDetails.av ? taxDetails.av.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commAv", taxDetails.commAv ? taxDetails.commAv.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.commRate", "50"));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.hbtAmount", taxDetails.hbtAmount ? taxDetails.hbtAmount.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.quateryAmount", taxDetails.quateryAmount ? taxDetails.quateryAmount.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.surcharge", taxDetails.surcharge ? taxDetails.surcharge.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.paybleAmount", taxDetails.paybleAmount ? taxDetails.paybleAmount.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.rebateAmount", taxDetails.rebateAmount ? taxDetails.rebateAmount.toString() : 0));
          dispatch((0, _actions3.prepareFinalObject)("Properties[0].taxdetails.netAmount", taxDetails.netAmount ? taxDetails.netAmount.toString() : 0));
        }
      }
    }
    return action;
  },

  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/taxCalculation.js
// module id = 1896
// module chunks = 1137